package com.seanshubin.vote.contract

import kotlinx.serialization.Serializable

@Serializable
data class RenameTierRequest(
    val oldName: String,
    val newName: String,
)
